import React from "react";
import "./reservation.scss";
import {ApiEngine} from "api-engine";
import { downloadICS } from "../../utils/calendar";
import { hapticSelect } from "../../utils/haptic";
import { appStartOfToday } from "../../utils/timezone";

interface ReservationProps {
  reservation: any;
  api: ApiEngine;
  index?: number;
}

interface ReservationState {}

function pad(_num: number, size: number) {
  let num = _num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export default class ReservationView extends React.Component<ReservationProps, ReservationState> {
  constructor(props: ReservationProps) {
    super(props);
    this.state = {};
    this.addToCalendar = this.addToCalendar.bind(this);
    this.getCalendarEvent = this.getCalendarEvent.bind(this);
  }

  getCalendarEvent() {
    const me = this;
    const reservation = me.props.reservation;

    // seconds_start is seconds-of-day in the application timezone (Europe/Moscow)
    // for today. Anchor to app-tz midnight so startDate/endDate are the correct
    // absolute instants regardless of the browser's timezone; the .ics is then
    // emitted in UTC so any calendar client shows the right wall-clock time.
    const start = appStartOfToday().add(reservation.seconds_start, "second");
    const end = start.add(reservation.duration, "second");
    const startDate = start.toDate();
    const endDate = end.toDate();

    return {
      title: `Переговорка: ${reservation.meeting_room?.title || 'Бронирование'}`,
      description: 'Бронирование переговорки\\nhttps://schedule.skobeltsyn.com',
      location: reservation.meeting_room?.title || '',
      startDate,
      endDate,
    };
  }

  addToCalendar() {
    hapticSelect();
    const event = this.getCalendarEvent();
    downloadICS(event);
  }

  render() {
    let me = this;
    let _dateStart = new Date(me.props.reservation.seconds_start * 1000 );
    let _dateEnd = new Date(me.props.reservation.seconds_start * 1000 + 1000 * me.props.reservation.duration );
    let dateStart = new Date(_dateStart.getTime() + 0 * 1000 * 60 * _dateStart.getTimezoneOffset());
    let dateEnd = new Date(_dateEnd.getTime() + 0 * 1000 * 60 * _dateEnd.getTimezoneOffset());

    // Stagger the appear animation by list position (capped so a long list
    // doesn't drag on).
    let appearDelay = `${Math.min(me.props.index ?? 0, 8) * 0.06}s`;
    return <div className={"reservation"} style={{animationDelay: appearDelay}}>
      <img
        src={`${me.props.api.serverUrl}${me.props.reservation.meeting_room.image_url}`}
        alt={`Переговорная комната ${me.props.reservation.meeting_room.title}`}
      />
      <div className={"content"}>
        <p style={{display: "none"}}>{JSON.stringify(me.props.reservation)}</p>
        <div className={"column"}>
          <p>{me.props.reservation.meeting_room.title}</p>
          <p className={"time"}>{`${pad(dateStart.getUTCHours(), 2)}:${pad(dateStart.getUTCMinutes(), 2)}`}-{`${pad(dateEnd.getUTCHours(), 2)}:${pad(dateEnd.getUTCMinutes(), 2)}`}</p>
        </div>
        <button
          className={"calendar-btn"}
          onClick={(e) => {
            e.stopPropagation();
            me.addToCalendar();
          }}
          title="Добавить в календарь"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="calendar-icon">
            <path d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm304-64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z" className="fa-secondary"/>
            <path d="M448 112v80H0v-80a48 48 0 0 1 48-48h48v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h128v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h48a48 48 0 0 1 48 48z" className="fa-primary"/>
          </svg>
        </button>
        <p className={"id"}>{me.props.reservation.id}</p>
      </div>
    </div>
  }
}